import { Action } from '@ngrx/store';
import {
  Vehicle,
  WorkOrder,
  WorkOrderCase,
  WorkorderDeclinedMpviCode
 } from '@quorum/models/xs-resource';
import { WorkOrderQueryParameters } from '@quorum/models/xs-query';

export const GET_WORK_ORDERS_FROM_SERVER = '[FIXED OPERATIONS] Get Work Orders From Server';
export class GetWorkOrdersFromServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_WORK_ORDERS_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: WorkOrderQueryParameters) {}
}

export const GET_WORK_ORDERS_FROM_SERVER_SUCCESS = '[FIXED OPERATIONS] Get Work Orders From Server Success';
export class GetWorkOrdersFromServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_WORK_ORDERS_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { workOrders: WorkOrder[] }) {}
}

export const GET_WORK_ORDERS_FROM_SERVER_FAILURE = '[FIXED OPERATIONS] Get Work Orders From Server Failure';
export class GetWorkOrdersFromServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_WORK_ORDERS_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const GET_WORK_ORDER_FROM_SERVER = '[FIXED OPERATIONS] Get Work Order From Server';
export class GetWorkOrderFromServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_WORK_ORDER_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { id: number; query: WorkOrderQueryParameters }) {}
}

export const GET_WORK_ORDER_FROM_SERVER_SUCCESS = '[FIXED OPERATIONS] Get Work Order From Server Success';
export class GetWorkOrderFromServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_WORK_ORDER_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { workOrder: WorkOrder }) {}
}

export const GET_WORK_ORDER_FROM_SERVER_FAILURE = '[FIXED OPERATIONS] Get Work Order From Server Failure';
export class GetWorkOrderFromServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_WORK_ORDER_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const POST_WORK_ORDER_CASE_TO_SERVER = '[FIXED OPERATIONS] Post Work Order Case To Server';
export class PostWorkOrderCaseToServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_WORK_ORDER_CASE_TO_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { case: WorkOrderCase; vehicle: Vehicle }) {}
}

export const POST_WORK_ORDER_CASE_TO_SERVER_SUCCESS = '[FIXED OPERATIONS] Post Work Order Case To Server Success';
export class PostWorkOrderCaseToServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_WORK_ORDER_CASE_TO_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { case: WorkOrderCase }) {}
}

export const POST_WORK_ORDER_CASE_TO_SERVER_FAILURE = '[FIXED OPERATIONS] Post Work Order Case To Server Failure';
export class PostWorkOrderCaseToServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_WORK_ORDER_CASE_TO_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const POST_DECLINED_SERVICE_TO_WORKORDER_TO_SERVER =
  '[FIXED OPERATIONS] Post Declined Service to Workorder to Server';
export class PostDeclinedServiceToWorkOrderToServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_DECLINED_SERVICE_TO_WORKORDER_TO_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { declinedMpviCode: WorkorderDeclinedMpviCode; rooftop: number }) {}
}

export const POST_DECLINED_SERVICE_TO_WORKORDER_TO_SERVER_SUCCESS =
  '[FIXED OPERATIONS] Post Declined Service to Workorder to Server Success';
export class PostDeclinedServiceToWorkOrderToServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_DECLINED_SERVICE_TO_WORKORDER_TO_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { declinedMpviCode: WorkorderDeclinedMpviCode }) {}
}

export const POST_DECLINED_SERVICE_TO_WORKORDER_TO_SERVER_FAILURE =
  '[FIXED OPERATIONS] Post Declined Service to Workorder to Server  Failure';
export class PostDeclinedServiceToWorkOrderToServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_WORK_ORDERS_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type WorkOrdersAction =
  | GetWorkOrdersFromServer
  | GetWorkOrdersFromServerSuccess
  | GetWorkOrdersFromServerFailure
  | GetWorkOrderFromServer
  | GetWorkOrderFromServerSuccess
  | GetWorkOrderFromServerFailure
  | PostWorkOrderCaseToServer
  | PostWorkOrderCaseToServerSuccess
  | PostWorkOrderCaseToServerFailure
  | PostDeclinedServiceToWorkOrderToServer
  | PostDeclinedServiceToWorkOrderToServerSuccess
  | PostDeclinedServiceToWorkOrderToServerFailure;
